// The backend names every appointment "<dispute name> appointment of <first name>";
// keep only the dispute name ("Claimant vs Respondent") for display.
const SUFFIX = " appointment of ";

export default (appointmentName) => {
  if (!appointmentName) return appointmentName;
  const index = appointmentName.lastIndexOf(SUFFIX);
  return index > -1 ? appointmentName.slice(0, index) : appointmentName;
};
